import generateTypes from 'redux/utils/generateTypes';

// Action types for AddEditModule management
export const OPEN_WIDGET_EDITOR = 'OPEN_WIDGET_EDITOR';
export const CLOSE_WIDGET_EDITOR = 'CLOSE_WIDGET_EDITOR';
export const UPDATE_WIDGET_CONFIGURATION = 'UPDATE_WIDGET_CONFIGURATION';
export const SET_WIDGET_CONTEXT = 'SET_WIDGET_CONTEXT';
export const RESET_WIDGET_EDITOR = 'RESET_WIDGET_EDITOR';

// Widget editor context types
export const WIDGET_CONTEXT_TYPES = {
    APP_DESIGNER: 'APP_DESIGNER',
    WEB_DESIGNER: 'WEB_DESIGNER',
    MENU_PAGE: 'MENU_PAGE',
    NAVIGATION_CONTAINER: 'NAVIGATION_CONTAINER',
    PAGE_DETAIL: 'PAGE_DETAIL',
    CONTAINER_WIDGET: 'CONTAINER_WIDGET',
};
